<template>
  <div class="container3">
    <!-- <p style=" width: 98.9%; border-radius: 5px;padding: 10px 0 10px 16px;background: rgb(187, 208, 247);">在线专家</p> -->
    <div class="title">
        <p>在线专家</p>
        
        <el-button type="primary" round @click="handleExpert">
            更多<i class="el-icon-arrow-right"></i>
        </el-button>
    </div>
    <div class="main-box">
      <div class="nav">
        <el-popover
          :placement="widthNew?'right-start':'bottom-end'"
          class="popper-class"
          :width="widthNew?'650':'300'"
          trigger="hover"
        >
          <p slot="reference" class="slotPoper" :class="active==1?'slotPoperColor':''">行业</p>
          <div class="listPoper">
              <p v-for="item in industryList" :key="item.cate_id" @click="handleIndustry(item,1)">
                {{ item.cate_name }}
              </p>
          </div>
        </el-popover>
        <el-popover
          :placement="widthNew?'right-start':'bottom-end'"
          :width="widthNew?'650':'300'"
          class="popper-class"
          trigger="hover"
        >
          <p slot="reference" class="slotPoper" :class="active==2?'slotPoperColor':''">领域</p>
          <div class="listPoper">
              <p v-for="item in fieldList" :key="item.cate_id"  @click="handleIndustry(item,2)">
                {{ item.cate_name }}
              </p>
          </div>
        </el-popover>
        <el-popover
        :placement="widthNew?'right-start':'bottom-end'"
          :width="widthNew?'650':'300'"
          class="popper-class"
          trigger="hover"
        >
          <p slot="reference" class="slotPoper" :class="active==3?'slotPoperColor':''">专项</p>
          <div class="listPoper">
              <p v-for="item in specialList" :key="item.cate_id" @click="handleIndustry(item,3)">
                {{ item.cate_name }}
              </p>
          </div>
        </el-popover>
        <el-popover
          :placement="widthNew?'right-start':'bottom-end'"
          :width="widthNew?'650':'300'"
          class="popper-class"
          trigger="hover"
        >
          <p slot="reference" class="slotPoper" :class="active==4?'slotPoperColor':''">供需</p>
          <div class="listPoper">
              <p v-for="item in supplyList" :key="item.cate_id" @click="handleIndustry(item,4)">
                {{ item.cate_name }}
              </p>
          </div>
        </el-popover>
        <el-popover
          :placement="widthNew?'right-start':'bottom-end'"
          :width="widthNew?'650':'300'"
          class="popper-class"
          trigger="hover"
        >
          <p slot="reference" class="slotPoper" :class="active==5?'slotPoperColor':''">推荐</p>
          <div class="listPoper">
              <p v-for="item in companyList" :key="item.cate_id" @click="handleIndustry(item,5)">
                {{ item.cate_name }}
              </p>
          </div>
        </el-popover>
      </div>
      <div class="main">
        <!-- <div class="main-1" v-for="item in 2" :key="item"> -->
          <div class="main-card" v-for="item in listarticle" :key="item.id" @click="handleDetail(item)">
            <div class="card-img">
              <div v-show="item.firstFile.FileUrl" class="imageWidth">
                <img :src="item.firstFile.FileUrl" style="width: 100%;height: 180px; object-fit: cover;border-radius:15px" alt="">
              </div>
            </div>
            <div class="card-info">
              <div class="top">
                <div class="expert">
                  <p>{{ item.name }}</p>
                  <span>{{ item.title }}</span>
                </div>
                <div class="buttonClass">
                  <el-button round>在线咨询</el-button>
                </div>
              </div>
              <p>擅长方向：{{ item.expert }}</p>
              <p>技术领域：{{ item.technology }}</p>
              <p>任职机构：{{ item.position }}</p>
            </div>
          </div>
        <!-- </div> -->
        
      </div>
     
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      popoverVisible: false,
      widthNew:false,
      supplyList: [],
      fieldList: [],
      specialList: [],
      industryList: [],
      companyList: [],
      active: 0,
      listarticle: []
    }
  },
  methods: {
    showPopover() {
      this.popoverVisible = true;
    },
    handleIndustry(item,val){
      console.log(item);
      this.active = val
      if(val == 1){
        let data = {
          pageNum: 1,
          pageSize: 4,
          industry: item.cate_id,
          field: '',
          special: '',
          supply: '',
          recommendIds: '',
          name: ''
        }
        this.listExpert(data)
      }else if(val == 2){
        let data = {
          pageNum: 1,
          pageSize: 4,
          industry: '',
          field: item.cate_id,
          special: '',
          supply: '',
          recommendIds: '',
          name: ''
        }
        this.listExpert(data)
      }else if(val == 3){
        let data = {
          pageNum: 1,
          pageSize: 4,
          industry: '',
          field: '',
          special: item.cate_id,
          supply: '',
          recommendIds: '',
          name: ''
        }
        this.listExpert(data)
      }else if(val == 4){
        let data = {
          pageNum: 1,
          pageSize: 4,
          industry: '',
          field: '',
          special: '',
          supply: item.cate_id,
          recommendIds: '',
          name: ''
        }
        this.listExpert(data)
      }else if(val == 5){
        let data = {
          pageNum: 1,
          pageSize: 4,
          industry: '',
          field: '',
          special: '',
          supply: '',
          recommendIds: item.cate_id,
          name: ''
        }
        this.listExpert(data)
      }

    },
    listExpert(data){
      this.$store.dispatch('menu/listexpert',data)
                .then(res => {
                
                    if(res.ok){
                        this.listarticle = res.data.items
                       
                    }
                    

                }).catch(err => {
                    console.log(err);
                })
    },
    handleExpert(){
      this.$router.push({
          path: '/expert',
      })
      sessionStorage.setItem("name",'在线专家') 
    },
    handleDetail(item){
        // this.$router.push({
        //     path: '/detailInfo',
        //     query: {
        //         id : item.id
        //     }
        // })
        const { href } = this.$router.resolve({
            path: "/detailInfo",
            query: {
                id: item.id
            }
        });
        window.open(href, '_blank');
    }
  },
  mounted(){
    let data = {
      pageNum: 1,
      pageSize: 99999,
      cate_values: ['industry','special','field','supply','company']
    }
    this.$store.dispatch('menu/menuList',data)
      .then(res => {
        if(res.ok){
          console.log('res')
          console.log(res)
          let list = res.data.items
          if(list.length>0){
            list.forEach(item => {
              if(item.channel == 'industry'){
                this.industryList.push(item)
              }else if(item.channel == 'special'){
                this.specialList.push(item)
              }else if(item.channel == 'field'){
                this.fieldList.push(item)
              }else if(item.channel == 'supply'){
                this.supplyList.push(item)
              }else if(item.channel == 'company'){
                this.companyList.push(item)
              }
            });
          }
          
        }
      })

    let list = {
      pageNum: 1,
      pageSize: 4,
      industry: '',
      field: '',
      special: '',
      supply: '',
      name: ''
    }
    this.listExpert(list)
  },
  created(){
    let widthNew = document.documentElement.clientWidth
    if(widthNew > 540){
        this.widthNew = true
    }else{
        this.widthNew = false
    }
  }
}
</script>
<style>
.popper-class{
  height: 700px;
  overflow: auto;
}
.popper-class .el-button{
    width: 80%;
    margin-bottom: 10px;
}
</style>
<style scoped>
.container3{
  width: 1180px;
  margin-top: 20px;
  background: #fff;
  padding: 10px 10px;
  /* background: yellowgreen; */
}


.main-box .main{
  width: 950px;
  margin-top: 5px;
  max-height: 440px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
  border-radius: 10px;
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  overflow: hidden;
}
.main-box .main  .main-card{
  width: 455px;height: 200px;
  /* background: rgb(209, 223, 250,0.4); */
  margin: 10px 5px 5px 10px;
  border: 1px solid #f2f2f2;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.card-img{
  width: 160px;height: 180px;
  margin-left: 10px;
  border-radius: 15px;
  background: #9fb2c6;
}
.card-img .imageWidth{
  width: 160px;
  height: 180px;
}
.card-info{
  width: 55%;height: 180px;
  margin: 0 10px 0 5px;
  padding-top: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.card-info .top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

}
.card-info p{
  font-size: 16px;
  height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.card-info .top .expert{
  height: 70px;
}
.card-info .top .expert p{
  font-size: 20px;
}
.card-info .top .expert span{
  font-size: 13px;
  color: #bbbbbb;
}
.listPoper{
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  padding: 10px 10px;
}
.listPoper p{
  margin: 8px 8px 12px 8px;
  cursor: pointer;
  font-size: 18px;
}
.listPoper p:hover{
  color: #008a8a;
  font-weight: 600;
}

.slotPoper:hover{
  background: rgb(0, 168, 168, 0.1);
}
.slotPoperColor{
  color: #008a8a;
  background: rgb(0, 168, 168, 0.1);
}

.container3 .title{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid #f2f2f2;
  border-radius: 5px;
  font-size: 22px;
  font-weight: 700;
  /* background: rgb(209, 223, 250,0.4); */
}
.container3 .title p{
  font-size: 22px;
  /* background: rgb(187, 208, 247);    */
  padding: 15px 15px;
  border-radius: 15px;
  margin-right: 60px;
}
.container3 .title span{
  cursor: pointer;
  font-size: 16px;
}
.container3 .title span:hover{
  color: #00a8a8;
}

.buttonClass .el-button{
  background: #00a8a8;
  /* border: 1px solid #008a8a; */
  color: #fff;
}
@media screen and (min-width: 541px) {
    
  .main-box{
    display: flex;
    justify-content: space-between;
  }
  .main-box .nav{
    width: 200px;height: 300px;
    padding: 10px 0 10px 0;
    text-align: center;
    margin-top: 10px;
    
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
  }
  .slotPoper{
    padding: 10px 10px;
    width: 180px;
    line-height: 36px;
    text-align: center;
    font-size: 20px;
    cursor: pointer;
    background: #F5F7F9;
  }
}
@media screen and (max-width: 540px) {
  .container3{
    width: 100%;
    padding: 0 0;
    /* padding: 10px 0 10px 5px; */
    /* background: yellowgreen; */
  }
  
  .container3 .title{
    
    font-size: 18px;
  }
  .container3 .title p{
    font-size: 18px;
    /* background: rgb(187, 208, 247);    */
    padding: 15px 5px;
    border-radius: 15px;
    margin-right: 60px;
  }
  .container3 .title span{
    cursor: pointer;
    font-size: 16px;
  }
  
  .main-box .nav{
    width: 97%;
    height: 60px;
    padding: 0px 0 0px 0;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 15px;
    margin-left: 5px;
    display: flex;
    justify-content: space-between;
    background: #F5F7F9;
    
  }
  .slotPoper{
    padding: 10px 10px;
    /* width: 20%; */
    /* border: 1px solid; */
    /* margin-right: 10px; */
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    background: #F5F7F9;
  }
    
  .main-box .main{
    width: 100%;
    margin-top: 5px;
    max-height: 880px;
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
    border-radius: 10px;
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    overflow: hidden;
  }
  .main-box .main  .main-card{
    width: 97%;
    margin: 10px 5px 5px 5px;
   
  }

  .card-img{
    width: 130px;height: 180px;
    margin-left: 10px;
    border-radius: 15px;
    background: #9fb2c6;
  }
  .card-img .imageWidth{
    width: 130px;
    height: 180px;
  }
  .card-info{
    width: 55%;height: 180px;
    margin: 0 10px 0 5px;
    padding-top: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .card-info .top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;

  }
  .card-info p{
    font-size: 14px;
    height: 30px;
  }
  .card-info .top .expert{
    height: 50px;
  }
  .card-info .top .expert p{
    font-size: 18px;
  }
  .card-info .top .expert span{
    font-size: 13px;
    color: #bbbbbb;
  }
}
</style>